import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { IconX } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type ProfileSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  isSaving: boolean;
  children: ReactNode;
};

export const ProfileSettingsDialog = ({
  isOpen,
  onClose,
  isSaving,
  children,
}: ProfileSettingsDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={isSaving ? () => undefined : onClose}
      className="relative z-50"
    >
      <div
        data-profile-overlay-backdrop
        className="fixed inset-0 z-[60] bg-black/50"
        aria-hidden="true"
      />
      <div className="fixed inset-0 z-[60] overflow-y-auto p-4">
        <div className="flex min-h-full items-center justify-center">
          <DialogPanel className="relative flex max-h-[calc(100vh-2rem)] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-rw-neutral-lighter-gray px-6 py-4">
              <DialogTitle
                as="h2"
                className="text-xl font-medium leading-7 text-rw-neutral-rich-black"
              >
                {t('会員情報')}
              </DialogTitle>
              <button
                type="button"
                onClick={onClose}
                disabled={isSaving}
                data-autofocus
                aria-label={t('閉じる')}
                className="rounded-md p-1 text-rw-neutral-gray transition-colors hover:bg-rw-neutral-off-white hover:text-rw-neutral-rich-black focus:outline-none focus:ring-2 focus:ring-primary-teal disabled:cursor-not-allowed disabled:opacity-50"
              >
                <IconX className="size-5" aria-hidden="true" />
              </button>
            </div>
            <div className="overflow-y-auto p-6">{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
